import { render, staticRenderFns } from "./CertificatesAndCourses.vue?vue&type=template&id=04e104b4&scoped=true"
import script from "./CertificatesAndCourses.vue?vue&type=script&lang=js"
export * from "./CertificatesAndCourses.vue?vue&type=script&lang=js"
import style0 from "./CertificatesAndCourses.vue?vue&type=style&index=0&id=04e104b4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e104b4",
  null
  
)

export default component.exports